import TaskCard from "./TaskCard";

function Board({ title, tasks, setTasks, onEdit }) {

  const onDrop = (e) => {
    const id = e.dataTransfer.getData("taskId");
    setTasks(
      tasks.map(t =>
        t.id.toString() === id ? { ...t, status: title } : t
      )
    );
  };

  return (
    <div
      onDragOver={(e) => e.preventDefault()}
      onDrop={onDrop}
      style={{
        width: "30%",
        minHeight: "400px",
        padding: "10px",
        background: "#f2f2f2"
      }}
    >
      <h3>{title}</h3>

      {tasks
        .filter(t => t.status === title)
        .map(task => (
          <TaskCard
            key={task.id}
            task={task}
            tasks={tasks}
            setTasks={setTasks}
            onEdit={onEdit}
          />
        ))}
    </div>
  );
}

export default Board;